import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {EndpointService} from './endpoint.service';
import {BaseResponse} from '../responses/BaseResponse';
import {GetCustomFieldsRequest} from '../requests/GetCustomFieldsRequest';
import {GetCustomFieldsResponse} from '../responses/GetCustomFieldsResponse';
import {AddUserCustomFieldRequest} from '../requests/AddUserCustomFieldRequest';
import {CheckUserCustomFieldResponse} from '../responses/CheckUserCustomFieldResponse';

@Injectable({providedIn: 'root'})
export class CustomFieldService {
  constructor(private http: HttpClient) { }

  getCustomFields(data: GetCustomFieldsRequest) {
    return this.http.post<GetCustomFieldsResponse>(EndpointService.getCustomFields, data);
  }

  addUserCustomField(data: AddUserCustomFieldRequest) {
    return this.http.post<BaseResponse>(EndpointService.addUserCustomField, data);
  }

  checkUserCustomFieldRegister(userId: string) {
    return this.http.get<CheckUserCustomFieldResponse>(EndpointService.checkUserCustomFieldRegister, {params: new HttpParams().set('userId', userId)});
  }
}
